import {
    HorizAlignment,
    ISearch,
    ISearchProfile,
    ISearchProvider,
    ISearchProviderField,
    ISearchRequestSubset,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PASearch} from "../PA.Core/PASearch";
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import * as _ from "lodash";

const vUI_Hierarchy_Editor_Search_Fields: { [id: string]: ISearchProviderField } = {
    WB_HIERARCHY_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {columnName: 'Wb Hierarchy Id', columnResourceName: 'colId', alignment: HorizAlignment.Left},
        domainOptions: {}
    },
    HIERARCHY_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'ID',
            columnResourceName: 'colHierarchyId',
            alignment: HorizAlignment.Left
        },
        domainOptions: {maxLength: 50}
    },
    HIERARCHY_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Name',
            columnResourceName: 'colHierarchyName',
            alignment: HorizAlignment.Left
        },
        domainOptions: {maxLength: 50}
    },
    MDSET_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Master Data Set Id',
            columnResourceName: 'colMDSetId',
            alignment: HorizAlignment.Left
        },
        domainOptions: {maxLength: 50}
    },
    MDSET_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Master Data Set Name',
            columnResourceName: 'colMDSetName',
            alignment: HorizAlignment.Left
        },
        domainOptions: {maxLength: 50,
            profileId: "default",
            bUseSearchProvidersDistinctValues: true}
    },
    ENTITY_DIMENSION: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Domain',
            columnResourceName: 'colDomain',
            alignment: HorizAlignment.Left
        },
        domainOptions: {
            domainIds: ['ENTITY_DIMENSION'],
            useIdAsKey: true,
            maxLength: 20,
            domainItemSubCode: 'Hierarchy'
        }
    },
    HIERARCHY_STATUS: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Status',
            columnResourceName: 'colStatus',
            alignment: HorizAlignment.Left
        },
        domainOptions: {
            domainIds: ['HierarchyStatus'],
            useIdAsKey: true
        }
    },

    REL_COUNT: {
        type: SearchProviderFieldType.number,
        renderOptions: {columnName: 'Relationship Count', columnResourceName: 'colRelationships', alignment: HorizAlignment.Right, numberFormat: "#,##0"},
        domainOptions: {}
    },
    NODE_COUNT: {
        type: SearchProviderFieldType.number,
        renderOptions: {columnName: 'Node Count', columnResourceName: 'colRelationships', alignment: HorizAlignment.Right, numberFormat: "#,##0"},
        domainOptions: {}
    },
    CREATED_DTTS: {
        type: SearchProviderFieldType.saptimestamp,
        renderOptions: {
            columnName: 'Created Date',
            columnResourceName: 'colCreateDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM/dd/yyyy"
        },
        domainOptions: {}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.saptimestamp,
        renderOptions: {
            columnName: 'Modified Date',
            columnResourceName: 'colModifiedDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM/dd/yyyy"
        },
        domainOptions: {}
    },
}

const HierarchySearchProviderBasic: ISearchProvider = {

    keyFields: {
        id: 'WB_HIERARCHY_ID',
        id_ui: 'HIERARCHY_ID',
        name: 'HIERARCHY_NAME'

    },

    searchProviderFields: vUI_Hierarchy_Editor_Search_Fields,

    search(searchRequestSubset: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {
            let findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
                'vUI_Hierarchy_Editor_Search',
                this.searchProviderFields,
                []);

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res)
                })
                .catch((err) => {
                    error(err)
                });
        })
    },

    distinctValues(fieldName: string): Promise<string[] | number[]> {
        return new Promise<string[] | number[]>((resolve, error) => {
            let findRequest = SearchUtils.makeSearchRequest({},
                'vUI_Hierarchy_Editor_Search',
                this.searchProviderFields,
                [fieldName])

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(_.map(res, (aRow) => {
                        return aRow[fieldName]
                    }))
                })
                .catch((err) => {
                    error(err)
                })
        })
    }

};

const HierarchySearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by ID, Name",
    renderOptions: {ui5SourceId: "HierarchySearchProfileByName"},

    profileFilter: [
        {profileFilterName: 'ID', searchProviderFieldId: 'HIERARCHY_ID', renderOptions: {}},
        {profileFilterName: 'Name', searchProviderFieldId: 'HIERARCHY_NAME', renderOptions: {}},
        {profileFilterName: 'Master Data Set', searchProviderFieldId: 'MDSET_NAME', renderOptions: { }, bMultiSelect: true},
        {profileFilterName: 'Domain', searchProviderFieldId: 'ENTITY_DIMENSION', renderOptions: {}}
    ], //ISearchFields
    profileDisplayFields: [
        'HIERARCHY_ID', 'HIERARCHY_NAME', 'ENTITY_DIMENSION', 'HIERARCHY_STATUS', 'REL_COUNT',
        {fields: ['MDSET_NAME', 'MDSET_ID'], columnTitle: "MD Set", seperator: " - "},
        'CREATED_DTTS', 'MODIFIED_DTTS'
    ],

    profileSearchProvider: HierarchySearchProviderBasic,
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
};

const HierarchyEditorSearch: ISearch = {
    searchName: "Find Hierarchy",
    renderOptions: {ui5ResourceId: "HierarchySearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [HierarchySearchProfileByName]
};

_.forEach(vUI_Hierarchy_Editor_Search_Fields, (colSpec) => {
    if(colSpec.domainOptions.bUseSearchProvidersDistinctValues && !colSpec.domainOptions.search)
        colSpec.domainOptions.search = HierarchyEditorSearch
})


PAEnvironment.registerBusinessObjectSearch("HierarchyBO", "HierarchyEditor", HierarchyEditorSearch, "Hierarchy Editor Search")

export {HierarchyEditorSearch}